
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo} from "../Configuracion";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO, CELLTIPO_FECHA,
    CELLTIPO_FOREIGN, CELLTIPO_ICONOACCION, CELLTIPO_MONEDA, COLUMNVISIBLE_SIEMPRE,
    CELLTIPO_LISTA, CELLTIPOEDITOR_SELECTOR, CELLTIPO_SINO,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import FormularioBotonera, {
    BOTONERA_ACCION_ELIMINAR, BOTONERA_ACCION_MODIFICAR,
    BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {Icon, Intent, Spinner} from "@blueprintjs/core";
import GridRDG from "../../framework2/adazzle/GridRDG";
import Titulo from "../../framework2/ej2/UI/Titulo";
import Tratamiento from "./Tratamiento";
import PropTypes from "prop-types";
import Pago from "./Pago";
import {tiposPagos} from "../utils/Definiciones";
import {
    COMPONENTE_TIPO_DATE,
    COMPONENTE_TIPO_FOREIGN,
    COMPONENTE_TIPO_FOREIGN_SERVIDOR,
    COMPONENTE_TIPO_INPUT,
    COMPONENTE_TIPO_SELECT,
    renderGrid,
    renderFormulario,
    loadDatosServicio,
    showSelectBusqueda,
    COMPONENTE_TIPO_FLOTANTE, showInputBusqueda, COMPONENTE_TIPO_FOREIGN_PANTALLA, COMPONENTE_TIPO_BOOL,
} from "../utils/FormularioUtils";
import SelectorPeriodo from "../../framework2/ej2/UI/SelectorPeriodo";
import {
    getPeriodoAgnoActualTimestamp, getPeriodoDiaActual, getPeriodoDiaActualTimestamp,
    getPeriodoUltimoAgno,
    getPeriodoUltimoAgnoTimestamp
} from "../../framework2/ej2/utils/PeriodoUtils";
import {INPUT_FLOTANTE_MONEDA, INPUT_FLOTANTE_PORCENTAJE} from "../../framework2/ej2/UI/InputFlotante";
import Pacientes from "./Pacientes";

class Pagos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),

            //filtroFechas: getPeriodoUltimoAgnoTimestamp(),filtroFechas:  props.paciente ? getPeriodoAgnoActualTimestamp() : getPeriodoDiaActualTimestamp(),
            filtroFechas:  props.paciente ? getPeriodoUltimoAgnoTimestamp() : getPeriodoDiaActualTimestamp(),
            filtroTipo: 0,
            filtroConcepto: "",
        }

        this.columnas= [
            {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
                icon: "edit",
                onAccion: (elemento) => {
                    console.log(elemento);
                    this.setState({elementoSeleccionado: elemento, showGrid: false })
                }
            },
            {campo:"fecha", titulo: "Fecha", tipo: CELLTIPO_FECHA, ancho:100},
            {campo:"importe", titulo: "Importe", tipo: CELLTIPO_MONEDA, ancho:100},
            {campo:"tipo", titulo: "Típo", tipo: CELLTIPO_LISTA, valores: tiposPagos, ancho:100, filtroEncabezado: true},
            {campo:"concepto", titulo: "Concepto", tipo: CELLTIPO_CADENA, ancho:430},
            {campo:"alt", titulo: "Alt", tipo: CELLTIPO_SINO, ancho:50},
            {campo:"clinicaCodigo.nombre", titulo: "Clinica", tipo: CELLTIPO_CADENA, ancho:100},
        ];
        //console.log("props.paciente:", props.paciente);
        if (!props.paciente){
            this.columnas.splice(2, 0,
                {campo:"pacienteCodigo.codigoid", titulo: "Código", tipo: CELLTIPO_CADENA, ancho:60,},
                       {campo:"pacienteCodigo.nombre", titulo: "Paciente", tipo: CELLTIPO_CADENA, ancho:200,});
        }

        console.log("CONSTRUCTOR");
        console.log("props.estado.clinica: ", props.estado.clinica);


        this.elementoConfig= {
            className: "Pago",
            secciones: [
                {
                    titulo: "Datos ",
                    campos: [
                        {campo: "fecha", titulo: "Fecha", tipo: COMPONENTE_TIPO_DATE, cols: 1},
                        {campo: "tipo", titulo: "Tipo", tipo: COMPONENTE_TIPO_SELECT, valores: tiposPagos, cols: 2},
                        {campo: "importe", titulo: "Importe", tipo: COMPONENTE_TIPO_FLOTANTE, tipoFlotante: INPUT_FLOTANTE_MONEDA,
                            cols: 1, obligatorio: true},
                        {campo: "pacienteCodigo", titulo: "Paciente", tipo: COMPONENTE_TIPO_FOREIGN_PANTALLA, cols: 3, obligatorio: true,
                            clase: 'com.ej2sistemas.dental.modelo.Paciente',
                            formulario: <Pacientes />
                        },
                        {campo: "concepto", titulo: "Tratamiento", tipo: COMPONENTE_TIPO_INPUT, cols: 4, obligatorio: true},
                        {campo: "clinicaCodigo", titulo: "Clínica", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.clinicas, cols: 2, obligatorio: true},
                        {campo: "alt", titulo: "Alt", tipo: COMPONENTE_TIPO_BOOL, cols: 1},
                    ]
                },

            ]
        };
    }


    componentDidMount() {
        this.loadDatos();
    }

    loadDatos= () =>{
        const {filtroTipo, filtroFechas, filtroConcepto} = this.state;
        const {estado, paciente} = this.props;
        let parametros= {
            clinicaCodigo: estado.clinica.codigo,
            pacienteCodigo: paciente ? paciente.codigo : 0,
            tipo: Number(filtroTipo),
            fechas: filtroFechas,
            concepto: filtroConcepto,
        }
        console.log("LOAD DATOS ");
        console.log("parametros: ", parametros);

        loadDatosServicio(this, "Pago", "getLista", parametros, this.calcularTotal);
    }

    calcularTotal= (datosOriginales) => {
        let importeTotal= 0;
        datosOriginales.forEach( (dato, index) => {
           importeTotal+= dato.importe;
        });
        let importeTotalFormateado= importeTotal.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
        this.setState({importeTotal: importeTotalFormateado});
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_NUEVO:
                this.nuevoElemento();
                break;

            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
            default:
                break;
        }
    }

    nuevoElemento= () => {
        const{estado, paciente} = this.props;

        let elemento= {
            fecha: Date.now(),
            clinicaCodigo: estado.clinica,
            pacienteCodigo: paciente ? paciente : null,
            concepto: "TRATAMIENTO ODONTOLÓGICO",
            alt: false,
        } ;

        console.log("Nuevo Elemento");
        this.setState({elementoSeleccionado: elemento, showGrid: false});
    }

    onFormularioAceptado= () => {
        this.setState({showGrid: true}, this.loadDatos);
    }


    eliminarElemento= () => {
        const {elementoSeleccionado } = this.state;
        const {auth} = this.props;
        let url= servidor + servicioRestfulMinimo + "Pago/" + elementoSeleccionado.codigo + "/0/"+ auth.usuarioCodigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doDelete( response => {
            this.loadDatos();
        });
    }

    renderBusqueda= () => {
        const {filtroTipo, filtroConcepto} = this.state;
        const {paciente} = this.props;
        let periodoTipo= paciente ? 27 : 24;
        return (
          <div class="fr_contenedor_buscador" >
              <SelectorPeriodo className={"fr_selectorPeriodo"}
                               titulo={"Periodo fechas"} tipoValor={periodoTipo}
                               onChange={ (periodo) => this.setState({filtroFechas: periodo} )}
                               tiposOcultos={[22,23,25,26]}
                               width={400}
              />

              {showInputBusqueda("concepto", "Concepto", filtroConcepto,
                  (concepto) => this.setState({filtroConcepto: concepto.toUpperCase()}),
                    this.loadDatos) }

              {showSelectBusqueda("sTipos",  "Tipo", filtroTipo, tiposPagos,
                  (tipoCodigo) => this.setState({filtroTipo: tipoCodigo}),
                   this.loadDatos) }

              <button className="fr_boton refrescar"onClick={this.loadDatos}><Icon icon="refresh" style={{marginRight: 6}}/>Refrescar</button>
              <button className="fr_boton aceptar"onClick={this.nuevoElemento}><Icon icon="document" style={{marginRight: 6}}/>Nuevo</button>
          </div>
        );
    }

    render() {
        const {showGrid, datos, importeTotal} = this.state;
        const {paciente} = this.props;
        let propiedades={height: 400};
        return (
            <div style={{margin: 8, padding: 4}}>
                {!paciente && <Titulo titulo="Gestión de Pagos" soloTitulo={true} onNuevo={this.nuevoElemento}/> }
                {Boolean(showGrid) &&
                    <>
                        {this.renderBusqueda()}
                        {renderGrid(this, "Pagos", datos, this.onAccion, propiedades) }
                        <div className="fr_cuadroinformacion">
                            <span>Importe total </span><span><strong>{importeTotal}</strong></span>
                        </div>
                    </>
                }
                {!Boolean(showGrid) && renderFormulario(this, <Pago/>)}

            </div>
        )
    }
    
}

Pagos.propTypes = {
    paciente: PropTypes.object,
    llamador: PropTypes.object,
    titulo: PropTypes.string,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        datosmaestros: state.datosmaestros,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Pagos);



